import React from "react";
import previouslogo from "../../assets/3x/Left_new@3x.png";
import "../views/MapView.css";

const Previousbutton = (props) => {
  return (
    <img
      className="previous-btn"
      onClick={() => props.handlePrevious()}
      src={previouslogo}
      alt="next-button"
    />
  );
};

export default Previousbutton;
